import "./LiveDemoCallout.css";
import { motion, useReducedMotion } from "framer-motion";
import demoMenuImg from "../../assets/marketing/demo-menu-desktop.webp";

function LiveDemoCallout() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="landing-section landing-demo-section">
      <motion.div
        className="landing-demo-callout"
        initial={prefersReducedMotion ? false : { opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      >
        <div className="landing-demo-content">
          <span className="landing-eyebrow">Próbáld ki élőben</span>
          <h2>Nézd meg, milyen élményt kapnak a vendégeid</h2>
          <p>
            A Teszt Étterem élő, valódi Tablify menüje — regisztráció nélkül
            kipróbálhatod, pontosan úgy, ahogy egy vendég látná.
          </p>
          <a
            href="https://teszt-etterem.tablify.hu"
            className="landing-btn-secondary"
          >
            Nyisd meg élőben, regisztráció nélkül →
          </a>
        </div>

        <motion.div
          className="landing-demo-image"
          whileHover={prefersReducedMotion ? undefined : { y: -6 }}
          transition={{ duration: 0.3 }}
        >
          <div className="landing-mockup-frame landing-demo-browser">
            <div className="landing-demo-browser-bar">
              <span />
              <span />
              <span />
              <span className="landing-demo-browser-url">
                teszt-etterem.tablify.hu
              </span>
            </div>
            <img
              src={demoMenuImg}
              alt="Teszt Étterem valódi digitális étlapja böngészőben"
              loading="lazy"
            />
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}

export default LiveDemoCallout;
